export const editDirectoryListingInputTransform = (input) => {
  const transformedInput = { ...input };
  delete transformedInput.status;
  transformedInput.categories = (transformedInput.categories || []).map(category => category.category);
  return transformedInput;
};
